import React from 'react';
import { Button } from 'clad';
import styled from 'styled-components';

const sizesStyles = {
    big: {
        'padding-top': '100px',
        'max-width': '250px'
    },
    medium: {
        'padding-top': '50px',
        'max-width': '190px'
    },
    small: {
        'padding-top': '20px',
        'max-width': '120px'
    }
};

const styleH1 = {
    big: {
        fontSize: '28px'
    },
    medium: {
        fontSize: '22px'
    },
    small: {
        fontSize: '16px'
    }
};

const styleH3 = {
    big: {
        fontSize: '18px'
    },
    medium: {
        fontSize: '16px'
    },
    small: {
        fontSize: '12px',
        fontWeight: '200'
    }
};

const Container = styled.div`
    height: auto;
    width: 100%;
    margin: 0 auto;
    padding-top: ${props =>
        sizesStyles[props.size]
            ? sizesStyles[props.size]['padding-top']
            : '100px'};
    text-align: center;

    .create-button {
        color: white;
        background: #4bbb58;
    }

    .create-button:hover {
        background: #32873c;
    }

    .explain {
        line-height: 20px;
        color: #999;
    }

    img,
    h3 {
        margin-bottom: 10px;
        line-height: 5;
    }

    img {
        max-width: ${props =>
            sizesStyles[props.size]
                ? sizesStyles[props.size]['max-width']
                : '250px'};
    }
`;

const imgPath = 'static/images/empty-pages/';

export default class EmptyPage extends React.Component {
    render() {
        const { props } = this;
        const { type, actionBtn, buttonText, titleText } = props;
        const { _ } = global;
        const data = {
            'topics-topics': {
                title: _("There isn't any topic here yet"),
                description: _(
                    'A topic allows you to track your work or even assign code to it. Time to create your first task or issue'
                ),
                img: imgPath + 'topic_blank.png',
                btnText: _('Create a Topic')
            },
            'topics-releases': {
                title: _("There isn't any release topic here yet"),
                description: _(
                    'A Release allows you to group topics to deploy a new version of your code'
                ),
                img: imgPath + 'topic_blank.png',
                btnText: _('Create a Release')
            },
            'topics-changesets': {
                title: _("There isn't any changeset topic here yet"),
                description: _(
                    'A Changeset is a technical task with a branch associated to work and track your code'
                ),
                img: imgPath + 'topic_blank.png',
                btnText: _('Create a Changeset')
            },
            'topics-category': {
                description: actionBtn
                    ? _(
                          'Start creating your first topic to track your work or even assign code to it.'
                      )
                    : null,
                img: imgPath + 'topic_blank.png'
            },
            projects: {
                title: _('You have no projects yet'),
                description: _('Here you can see and manage your projects'),
                img: imgPath + 'project_blank.png',
                btnText: _('Create a Project')
            },
            labels: {
                title: _('You have no labels yet'),
                description: _('Here you can see and manage your labels'),
                img: imgPath + 'labels_blank.png',
                btnText: _('Create a Label')
            },
            'resource-dependencies': {
                title: _('No Dependencies'),
                description: _('This resource does not have any dependencies'),
                img: imgPath + 'repository_blank.png'
            },
            'resource-rules': {
                title: _('No Rules'),
                description: _('This resource is not being used by any rules'),
                img: imgPath + 'repository_blank.png'
            },
            'resource-topics': {
                title: _('No Topics'),
                description: _('This resource is not being used by any topics'),
                img: imgPath + 'repository_blank.png'
            },
            'resource-versions': {
                title: _('No Versions'),
                description: _('This resource does not have any versions yet'),
                img: imgPath + 'repository_blank.png'
            },
            repositories: {
                title: _("You haven't created a repository for this project"),
                description: _(
                    'Create and manage your repositories from project Settings -> Repositories'
                ),
                img: imgPath + 'repository_blank.png',
                btnText: _('Take me to Settings')
            },
            variables: {
                title: _("You don't have any variables yet"),
                description: _(
                    'Variables help making your rulebooks more usable. Create and manage your variables here.'
                ),
                img: imgPath + 'variable_blank.png',
                btnText: _('Create a Variable')
            },
            'docker-images': {
                title: _("You don't have docker images to manage"),
                description: _(
                    'Here you can manage the docker images that are stored in your instance'
                ),
                img: imgPath + 'docker-image_blank.png'
            },
            'docker-containers': {
                title: _("You don't have docker containers to manage"),
                description: _(
                    'Here you can manage the docker containers that are stored in your instance'
                ),
                img: imgPath + 'docker-container_blank.png'
            },
            'dashboards-all': {
                title: _('You have no dashboards yet'),
                description: _(
                    'Dashboards are useful to track everything that happens in Clarive. Start creating your custom dashboard now'
                ),
                img: imgPath + 'dashboards-all_blank.png'
            },
            'dashboards-personal': {
                title: _('You have no personal dashboards yet'),
                description: _('Start creating your custom dashboard now'),
                img: imgPath + 'dashboards-user_blank.png'
            },
            'dashboards-shared': {
                title: _('No dashboards shared with you'),
                description: _(
                    'You will see here the personal dashboards other users share with you'
                ),
                img: imgPath + 'dashboards-user_blank.png'
            },
            'dashboards-default': {
                title: _('No default dashboards to show'),
                description: _(
                    'You will see dashboards here created by admin user'
                ),
                img: imgPath + 'dashboards-default_blank.png'
            },
            'kanban-all': {
                title: _('You have no Boards yet'),
                description: _(
                    'Boards is the best tool to view and organise your tasks. You will see Boards here.'
                ),
                img: imgPath + 'kanban-all_blank.png',
                btnText: _('Create your first Board now')
            },
            'kanban-mine': {
                title: _('You have no personal kanban boards yet'),
                description: _('Here you will see your private Boards'),
                img: imgPath + 'kanban-mine_blank.png',
                btnText: _('Create your first Board now')
            },
            'kanban-shared': {
                title: _('Nobody shared a kanban board with you'),
                description: _(
                    'Boards can be shared from Configure button in a personal Board. You will see your shared kanban boards here'
                ),
                img: imgPath + 'kanban-shared_blank.png'
            },
            invitations: {
                title: _('No pending invitations'),
                description: _(
                    'Send an email and let people join this instance'
                ),
                img: imgPath + 'invitations_blank.png',
                btnText: _('Send Invitation')
            },
            'no-results': {
                title: _('No results found'),
                description: _('Type something to search'),
                img: imgPath + 'no-results_blank.png'
            },
            usergroups: {
                title: _('You have no user groups yet'),
                description: _(
                    'User Groups allow you to work with a set of users and give them permissions'
                ),
                img: imgPath + 'usergroups_blank.png'
            },
            'slack-notifications': {
                title: _('No notifications yet'),
                description: _('You will see your notifications here'),
                img: imgPath + 'slack-notifications.png',
                btnText: _('Create Notification')
            },
            statuses: {
                title: _('You have no statuses yet'),
                description: _('Here you can see and manage your statuses'),
                img: imgPath + 'labels_blank.png',
                btnText: _('Create a Status')
            },
            schedulers: {
                title: _('You have no scheduled tasks yet'),
                description: _(
                    'Here you can see and manage your scheduled tasks'
                ),
                img: imgPath + 'labels_blank.png',
                btnText: _('Create a Task')
            }
        };

        let { size } = props;

        let { title, description, img, btnText } = data[type] || props;

        if (type == null) {
            img = imgPath + img;
        }

        if (!size || !sizesStyles[size]) {
            size = 'big';
        }

        return (
            <Container className="empty-page" size={size}>
                <img src={img} />
                <div className="explain">
                    <h1 style={styleH1[size]}>{titleText || title}</h1>
                    <h3 style={styleH3[size]}>{description}</h3>

                    {actionBtn && (
                        <Button className="create-button" onClick={actionBtn}>
                            {buttonText || btnText}
                        </Button>
                    )}
                </div>
            </Container>
        );
    }
}
